var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"transition duration-200 transform",class:{ 'rotate-180': _vm.down },attrs:{"xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 256 256"}},[_c('path',{attrs:{"d":"M225.813 48.907 128 146.72 30.187 48.907 0 79.093l128 128 128-128z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }